<template>
  <VDialog width="500" v-model="dialog">
    <VCard>
      <VBtn @click="dialog = false" class="mt-3" icon absolute right>
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="mb-1">{{ $t("signed") }}</VCardTitle>
      <VCardSubtitle>{{ date | fullTimeParse }}</VCardSubtitle>
      <VCardText>
        <VSimpleTable>
          <tbody>
            <tr v-for="(item, index) in items" :key="`index-${index}`">
              <td>{{ item[0] }}</td>
              <td>{{ item[1] }}</td>
            </tr>
          </tbody>
        </VSimpleTable>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: "SignedInfoDialog",
  data() {
    return {
      dialog: false,
      items: [],
      date: null,
    };
  },
  methods: {
    open({ name, date }) {
      this.dialog = true;
      this.items = name.split(",").map((item) => item.split("="));
      this.date = date;
    },
  },
};
</script>
